import type { Difficulty } from "../nonogram/types";

/**
 * The site's navigation, written once.
 *
 * The React header, footer and board render these lists, and so does the pre-rendered
 * HTML. A crawler that never runs JavaScript still needs a way from any page to every
 * other, and two hand-kept copies of the same links drift without anyone noticing —
 * the header already pointed at an alias of the page it meant.
 */
export type NavLink = {
  href: string;
  label: string;
  /** A cramped label for fitting the row of links across a narrow screen. */
  short?: string;
  /** Prefix of the `-full` / `-short` span classes the stylesheet swaps between. */
  labelClass?: string;
  className?: string;
};

export const PRIMARY_NAV: NavLink[] = [
  // The root is the daily puzzle's canonical address, so it is the one the site links to.
  { href: "/", label: "Daily" },
  { href: "/nonogram", label: "Play" },
  { href: "/collection", label: "Collection", short: "Collect", labelClass: "collection" },
  { href: "/how-to-play-nonogram", label: "How to play", short: "How", labelClass: "how-to", className: "how-to-link" },
];

export const FOOTER_TAGLINE = "One thoughtful puzzle, every day.";

/** Secondary destinations only. Discovery belongs to the header and to the "Keep
    playing" block under the board, which can say why a link is worth following. */
export const FOOTER_NAV: NavLink[] = [
  { href: "/collection", label: "Collection" },
  { href: "/daily-nonogram/archive", label: "Archive" },
  { href: "/printable-nonograms", label: "Print" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
];

export const DIFFICULTY_NAV: Array<{ difficulty: Difficulty; label: string; size: string; href: string }> = [
  { difficulty: "easy", label: "Easy", size: "5×5", href: "/nonogram/easy" },
  { difficulty: "medium", label: "Medium", size: "10×10", href: "/nonogram" },
  { difficulty: "hard", label: "Hard", size: "15×15", href: "/nonogram/hard" },
  { difficulty: "hard", label: "Grand", size: "20×20", href: "/nonogram/20x20" },
  { difficulty: "hard", label: "Epic", size: "25×25", href: "/nonogram/25x25" },
];
